import axios from 'axios'
import router from '@/router'
import AuthMiddleware from '@/middlewares/authMiddleware'

const httpClientWithNoToken = axios.create({
  baseURL: process.env.VUE_APP_API_URL_BASE,
})

/*
 * APIレスポンスを受け取った時、
 * サーバからstatus code 401が返ってきた場合は、
 * 認証期限が切れているので、
 * 強制的にログインページに移動させる
 */
httpClientWithNoToken.interceptors.response.use(
  response => {
    return response
  },
  error => {
    const status = error.response.status
    // eslint-disable-next-line
    let message
    if (status === 401) {
      // 認証エラー
      // 強制ログアウトする
      AuthMiddleware.logout()
      message = '認証エラーです。再度ログインしてください。'
      router.push('/').catch(() => {})
    } else if (status === 403) {
      // 権限エラー
      message = '権限がありません。システム管理者へ連絡してください。'
    } else {
      message = '問題が発生しました。'
    }
    return Promise.reject(new Error(message))
  },
)

export default httpClientWithNoToken
